// The header is the logo's height, and the logo is the only thing in it that sets one: 100px from
// `md` up, a smaller bar and logo below it, where 100px took too much of a phone's screen.
export const HEADER_HEIGHT_PX = 100;
export const HEADER_HEIGHT_NARROW_PX = 64;

// For `sx`: the header's height on each side of `md`.
export const HEADER_HEIGHT_SX = { xs: `${HEADER_HEIGHT_NARROW_PX}px`, md: `${HEADER_HEIGHT_PX}px` };

// What a `#hash` link has to clear. The header is sticky, so a section scrolled to lands
// underneath it unless the browser is told to stop short — and stopping exactly at the
// header's edge leaves the heading welded to it, so the gap is part of the number.
const SECTION_GAP_PX = 28;

// An `sx` value, responsive like the header it clears.
export const SECTION_SCROLL_MARGIN = {
  xs: `${HEADER_HEIGHT_NARROW_PX + SECTION_GAP_PX}px`,
  md: `${HEADER_HEIGHT_PX + SECTION_GAP_PX}px`,
};
